/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Approved
 *
 * 2 = Submited
 *
 * 3 = Canceled
 *
 * 4 = Closed
 *
 * 5 = InProgress
 *
 * 6 = NotComplited
 */
export enum WarrantyClaimNoteStatusEnum {
  Approved = 1,
  Submited = 2,
  Canceled = 3,
  Closed = 4,
  InProgress = 5,
  NotComplited = 6,
}
